var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-conteudo-modal"},[_c(_setup.CartaoPrincipal,{attrs:{"dado":_vm.dado,"disabled":_vm.disabled}}),_c(_setup.CartaoItens,{attrs:{"itens":_vm.itensDaOS,"historico":_vm.historico,"disabled":true}}),_c(_setup.CartaoDatas,{attrs:{"dado":_vm.dado,"disabled":_vm.disabled}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }